module.exports = __webpack_public_path__ + "assets/filter.c18ab8a5.svg";